import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgB1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 170,
	height: 230,
	viewBox: "0 0 170 230",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6073_1132)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 170,
					height: 230,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.9669 143C45.3802 143 44.9002 142.813 44.5269 142.44C44.1535 142.067 43.9669 141.587 43.9669 141V89C43.9669 88.4133 44.1535 87.9333 44.5269 87.56C44.9002 87.1867 45.3802 87 45.9669 87H69.7269C74.1535 87 77.7802 87.64 80.6069 88.92C83.4335 90.2 85.5135 92.0133 86.8469 94.36C88.2335 96.7067 88.9269 99.4533 88.9269 102.6C88.9269 104.573 88.5535 106.307 87.8069 107.8C87.1135 109.293 86.2335 110.52 85.1669 111.48C84.1535 112.44 83.1669 113.16 82.2069 113.64C84.2869 114.6 86.1002 116.2 87.6469 118.44C89.2469 120.627 90.0469 123.24 90.0469 126.28C90.0469 129.64 89.3002 132.573 87.8069 135.08C86.3135 137.587 84.1002 139.533 81.1669 140.92C78.2335 142.307 74.6602 143 70.4469 143H45.9669ZM56.6869 133.64H68.9269C71.5402 133.64 73.5135 132.92 74.8469 131.48C76.1802 129.987 76.8469 128.227 76.8469 126.2C76.8469 124.12 76.1535 122.387 74.7669 121C73.4335 119.56 71.4869 118.84 68.9269 118.84H56.6869V133.64ZM56.6869 109.64H68.2069C70.7135 109.64 72.5802 109.027 73.8069 107.8C75.0869 106.52 75.7269 104.893 75.7269 102.92C75.7269 100.947 75.0869 99.3733 73.8069 98.2C72.5802 96.9733 70.7135 96.36 68.2069 96.36H56.6869V109.64ZM115.832 143C115.299 143 114.819 142.813 114.392 142.44C114.019 142.067 113.832 141.587 113.832 141V101.24L102.312 110.12C101.832 110.493 101.325 110.627 100.792 110.52C100.312 110.413 99.8852 110.12 99.5119 109.64L95.5119 104.44C95.1919 103.96 95.0585 103.453 95.1119 102.92C95.2185 102.387 95.5119 101.96 95.9919 101.64L114.232 87.56C114.552 87.3467 114.845 87.2133 115.112 87.16C115.432 87.0533 115.779 87 116.152 87H124.632C125.165 87 125.619 87.1867 125.992 87.56C126.365 87.9333 126.552 88.4133 126.552 89V141C126.552 141.587 126.365 142.067 125.992 142.44C125.619 142.813 125.165 143 124.632 143H115.832Z",
					fill: "#3B2C93"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 132.5,
					cy: 244.5,
					r: 56.5,
					fill: "#BFCEEF"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 28.5,
					cy: 19.5,
					r: 56.5,
					fill: "#BFCEEF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 169,
			height: 229,
			rx: 7.5,
			stroke: "#BBBFC7"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6073_1132",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 170,
				height: 230,
				rx: 8,
				fill: "white"
			})
		}) })
	]
});
export default SvgB1;
